$(document).ready(function(){

  // Product page redirects
  if (String(window.location.href).indexOf("/products/tikro-silko-pagalves-uzvalkalai") != -1 ){
    console.log('SHould be redirect');
    window.location = 'https://noreo.lt/products/noreo-naturalaus-silko-pagalves-uzvalkalas';
  }

  // Selecting by default first color, loading animations ant etc
  setTimeout(function(){
      var variant_id = String(window.location);
      variant_id = variant_id.split('?variant=');
      variant_id = variant_id[1];
      if (typeof(variant_id) != 'undefined'){
        variant_id = variant_id.substring(0, 14)
      var currentColor;
      $('.Product_form_variant_checker__js').each(function(){
        if ($(this).attr('data-id') == variant_id){
          currentColor = $(this).attr('data-variant-color');
          // console.log($(this).attr('data-id'), variant_id, '  testing =========================');
        }
      });

      console.log(currentColor, 'CURRENT COLOR');
        $('.'+currentColor+'_input_select__js').trigger('click');
        $('.gs_color_cell.'+currentColor).trigger('click');
        console.log(currentColor, 'CURRENT COLOR ===== ');
      }
      else{
        $('.First_variant_trigger').trigger('click');
      }
      // $('.First_variant_trigger').trigger('click');
      $('.Product_section_image_gallery').addClass('loaded');
      $('.Product_images_mob').addClass('loaded');
  },100);

  // Setting up random active users
  const min = 30;
  const max = 130;
  const active_users = Math.floor(Math.random() * (max - min + 1) + min);
  $('.Atc_active_users_js').text(active_users);


  function selectVariantId(){
    var currentColor = $('.gs_color_cell.active').attr('data');
    var currentSize = $('.gs_size_cell.active').attr('data');
    var title = currentColor + '-' + currentSize;
    var mode = parseFloat($('.gs_option_cell.active').attr('data'));


    $('.gs_price_selection').hide();
    $('.gs_variant_selector__js').each(function(){
      if ($(this).attr('data-title') == title){
        currentId = $(this).attr('data-id');
        currentInv = $(this).attr('data-inv');
      }
    });


    $('.gs_price_selection').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).show();
      }
    });
    $(".gs_single_variant_id").attr("data-id", currentId);
    if (mode == 1){
      if (currentInv < 1){
        $('.gs_atc_btn_text').text('Sold out');
      }
      else{
        $('.gs_atc_btn_text').text('Add to cart');
      }
    }

    
  }

  $('.gs_color_cell').click(function(){
    $('.gs_color_cell').removeClass('active');
    $(this).addClass('active');

    var data = $(this).attr('data-title');
    var data_handle = $(this).attr('data');

    $('.gs_color_label__js').text(data);
    $('.gs_size_container .gs_selector_label span').text(data);

    $('.Product_images_standard_gallery_main').slick('slickUnfilter');
    $('.Product_images_standard_gallery_thumb').slick('slickUnfilter');

    $('.Product_images_standard_gallery_main').slick('slickFilter', '.'+data_handle+'');
    $('.Product_images_standard_gallery_thumb').slick('slickFilter', '.'+data_handle+'');

    calculateStocks();
    selectVariantId();

  });

  $('.gs_size_cell').click(function(){
    $('.gs_size_cell').removeClass('active');
    $(this).addClass('active');

    if ($('.gs_size_cell.active').hasClass('soldout')){
      $('.gs_continue_btn p').text('Sold out');
      $('.gs_continue_btn').addClass('soldout');
    }
    else{
      $('.gs_continue_btn p').text('Pridėti ir tęsti pasirinkimą');
      $('.gs_continue_btn').removeClass('soldout');
    }
    selectVariantId();
  });

  $('.gs_select_size_btn').click(function(){

    $('.gs_color_container').hide();
    $('.gs_size_container').show();

    calculateStocks();
    
  });

  $('.gs_go_back').click(function(){
    $('.gs_color_container').show();
    $('.gs_size_container').hide();
  });

  $('.gs_option_cell').click(function(){
    $('.gs_option_cell').removeClass('active');
    $(this).addClass('active');

    $('.gs_variant_selector_product_arr').attr('data-products', '');
    $('.gs_variant_selector_product_arr').attr('data-sizes', '');
    $('.gs_variant_selector_product_arr').attr('data-colors', '');

    var amount = parseFloat($('.gs_option_cell.active').attr('data'));
    var currentAmount = 0;
    $('.gs_variant_selector_product_arr').attr('data-amount', '0');
    
    $('.gs_summary').hide();

    // var currentAmount = parseFloat($('.gs_variant_selector_product_arr').attr('data-amount'));
    console.log(amount, currentAmount);
    if (amount <= currentAmount){
      $('.gs_selector_atc_btn').removeClass('disabled');
    }
    else{
      $('.gs_selector_atc_btn').addClass('disabled');
    }

    if (amount == 1){
      $('.gs_color_container').show();
      $('.gs_size_container').show();

      $('.gs_go_back').hide();
      $('.gs_select_size_btn').hide();
      $('.gs_continue_btn').hide();
      $('.gs_selector_atc_btn').removeClass('disabled');
      $('.gs_color_label_multi').hide();
      $('.gs_color_label_single').show();
    }
    else{
      $('.gs_selector_atc_btn').addClass('disabled');
      $('.gs_size_container').hide();
      $('.gs_go_back').css('display', 'flex');
      $('.gs_select_size_btn').css('display', 'inline-block');
      $('.gs_continue_btn').css('display', 'inline-block');
      $('.gs_atc_btn_text').text('Add to cart');
      $('.gs_color_label_multi').show();
      $('.gs_color_label_single').hide();
    }

  });


  $('.gs_continue_btn').click(function(){
    if ($(this).hasClass('soldout')){

    }
    else{
      $('.gs_continue_btn').addClass('loading');
      setTimeout(function(){
        $('.gs_continue_btn').removeClass('loading');
      },2500);
      setTimeout(function(){
        $('.gs_color_container').show();
        $('.gs_size_container').hide();

        $('.gs_go_back').css('display', 'flex');
        $('.gs_select_size_btn').css('display', 'inline-block');
        $('.gs_continue_btn').css('display', 'inline-block');
      },2600);
      
      getGsProduct();
      var amount = parseFloat($('.gs_option_cell.active').attr('data'));
      var currentAmount = parseFloat($('.gs_variant_selector_product_arr').attr('data-amount'));
      console.log(amount, currentAmount);
      if (amount <= currentAmount){
        $('.gs_selector_atc_btn').removeClass('disabled');
      }
      else{
        $('.gs_selector_atc_btn').addClass('disabled');
      }
    }
  });

  function calculateStocks(){
    var currentColor = $('.gs_color_cell.active').attr('data');
    $('.gs_size_cell').each(function(){
      var currentSize = $(this).attr('data');
      var fullTitle = currentColor + '-' + currentSize;
      var currentInv = 0;

      $('.gs_variant_selector__js').each(function(){
        if ($(this).attr('data-title') == fullTitle){
          currentId = $(this).attr('data-id');
          currentInv = $(this).attr('data-inv');
        }
      });

      if (currentInv == 0){
        $(this).addClass('soldout');
      }
      else{
        $(this).removeClass('soldout');
      }

      if ($('.gs_size_cell.active').hasClass('soldout')){
        $('.gs_continue_btn p').text('Sold out');
        $('.gs_continue_btn').addClass('soldout');
      }
      else{
        $('.gs_continue_btn p').text('Pridėti ir tęsti pasirinkimą');
        $('.gs_continue_btn').removeClass('soldout');
      }

    });
  }

  function getGsProduct(){
    var currentColor = $('.gs_color_cell.active').attr('data');
    var currentSize = $('.gs_size_cell.active').attr('data');

    var currentColorTitle = $('.gs_color_cell.active').attr('data-title');
    var currentSizeTitle = $('.gs_size_cell.active').attr('data-title');

    var currentTitle = currentColor + '-' + currentSize;
    var currentId;
    var currentAmount = parseFloat($('.gs_variant_selector_product_arr').attr('data-amount'));
    currentAmount++;
    $('.gs_variant_selector_product_arr').attr('data-amount', currentAmount);


    $('.gs_variant_selector__js').each(function(){
      if ($(this).attr('data-title') == currentTitle){
        currentId = $(this).attr('data-id');
      }
    });

    var selectedAmount =  parseFloat($('.gs_option_cell.active').attr('data'));
    if (currentAmount == 0){
      $('.gs_color_bolded_label__js').text('Pasirinkite pirmąją spalvą:');
    }
    else if (currentAmount == 1){
      $('.gs_color_bolded_label__js').text('Pasirinkite antrąją spalvą:');
    }
    else if (currentAmount == 2){
      $('.gs_color_bolded_label__js').text('Pasirinkite trečiąją spalvą:');
    }
    else if (currentAmount > 2){
      $('.gs_color_bolded_label__js').text('Pasirinkite spalvą:');
    }

    if (selectedAmount <= currentAmount){
      $('.gs_option_cell').removeClass('active');
      if (currentAmount == 0){
        $('.gs_option_cell[data="1"]').addClass('active');
      }
      else if (currentAmount == 1){
        $('.gs_option_cell[data="1"]').addClass('active');
      }
      else if (currentAmount == 2){
        $('.gs_option_cell[data="2"]').addClass('active');
      }
      else if (currentAmount > 2){
        $('.gs_option_cell[data="4"]').addClass('active');
      }
    }
    

    var currentProducts = $('.gs_variant_selector_product_arr').attr('data-products');
    var currentSizes = $('.gs_variant_selector_product_arr').attr('data-sizes');
    var currentColors = $('.gs_variant_selector_product_arr').attr('data-colors');

    currentProducts = currentProducts + ';' + currentId;
    currentSizes = currentSizes + ';' + currentColorTitle + " | " + currentSizeTitle;
    currentColors = currentColors + ';' + currentColorTitle;

    $('.gs_variant_selector_product_arr').attr('data-products', currentProducts);
    $('.gs_variant_selector_product_arr').attr('data-sizes', currentSizes);
    $('.gs_variant_selector_product_arr').attr('data-colors', currentColors);


    var productsList = $('.gs_variant_selector_product_arr').attr('data-products');

    productsList = productsList.split(';');


    // console.log(productsList, 'products list');
    $('.gs_summ_item_line').hide();
    $('.gs_summ_item_line').attr('data-qty', '0');

    var totalPrice = 0;
    var totalCompare = 0;

    for (var i = 0; i < productsList.length; i++){
      if (i > 0){
        console.log(productsList[i]);
        $('.gs_summ_item_line').each(function(){
          if ($(this).attr('data-id') == productsList[i]){
            var currentQty = parseFloat($(this).attr('data-qty'));
            totalPrice = totalPrice + parseFloat($(this).attr('data-price'));
            totalCompare = totalCompare + parseFloat($(this).attr('data-compare'));

            currentQty++;
            $(this).css('display', 'flex');
            $(this).attr('data-qty', currentQty);
            $(this).find('.gs_summ_qty').text(currentQty);
            
          }
        });
      }
    }

    if (currentAmount > 1 && currentAmount < 4){
      totalPrice = totalPrice * 0.9;
    }
    else if (currentAmount > 3){
      totalPrice = totalPrice * 0.85;
    }
    totalPrice = (totalPrice/100).toFixed(2);
    totalCompare = (totalCompare/100).toFixed(2);

    $('.gs_summary_total_price p').html(totalPrice + ' € <s>' + totalCompare + ' €');

    $('.gs_summary').show();

  }

  // Variant selection catching, image gallery switching by variant

  $('.product-form__input.Size_selector input').click(function(){
    var data = $(this).attr('value');
    console.log(data);

    // Preselecting specific size
    if (String(data).indexOf('51x91') != -1){
      // console.log('special');
      if ( $('.product-form__input.Color_selector input[value="Šviesiai pilka"]').is(':checked') || $('.product-form__input.Color_selector input[value="Kreminė"]').is(':checked')){

      }
      else{
        if (!$('.product-form__input.Color_selector input[value="Kreminė"]').is(':checked')) {
            $('.product-form__input.Color_selector input[value="Kreminė"]').trigger('click');
        }
      }
     
      // // $('.product-form__input.Size_selector input[value="160x200"]').trigger('click');
      // $('.product_variant_option__180x200').css('opacity', '0.2');
      // $('.product_variant_option__240x260-be-gumos').css('opacity', '0.2');
      // $('.product_variant_option__160x200').css('opacity', '0.2');
      // $('.product_variant_option__90x200').css('opacity', '1');
    }

  });


  $('.ppc_selecotr_box').click(function(){
    $(this).closest('.ppc_selector_line').find('.ppc_selecotr_box').removeClass('active');
    $(this).addClass('active');

    var data = $(this).attr('data-color');
    var data_handle  = data;

    var data_name = $(this).attr('data-color-name');
    $(this).closest('.js.product-form__input').find('p').find('span').html(data_name);

    $('.Product_images_standard_gallery_main').slick('slickUnfilter');
    $('.Product_images_standard_gallery_thumb').slick('slickUnfilter');
    // console.log(data_handle, 'current color to be filtered');
    $('.Product_images_standard_gallery_main').slick('slickFilter', '.'+data_handle+'');
    $('.Product_images_standard_gallery_thumb').slick('slickFilter', '.'+data_handle+'');

    if ($(this).hasClass('totallySoldout')){
      $('.mn_atc_btn_text__soldout').show();
      $('.mn_atc_btn_text__add').hide();
    }
    else{
      $('.mn_atc_btn_text__soldout').hide();
      $('.mn_atc_btn_text__add').show();
    }
  });


  $('.product-form__input.Color_selector input').click(function(){
      var data = $(this).attr('value');

      console.log(data);
      if (String(data).indexOf('Kreminė') != -1 || String(data).indexOf('Šviesiai pilka') != -1){
        console.log('special');
        $('.product_variant_option__king-51x91-cm').show();
      }
      else{
        console.log($('.product-form__input.Size_selector input[data-value="king-51x91cm"]').is(':checked')); 
        if ($('.product-form__input.Size_selector input[data-value="king-51x91-cm"]').is(':checked')){
          $('.product-form__input.Size_selector input[value="Standartinis 51x66 cm"]').trigger('click');
        }
        $('.product_variant_option__king-51x91-cm').hide();
              
      }
        // console.log('special');
    
      

      // if (data == 'Rožinis auksas'){
      //   $('.Product_image_badge').show();
      // }
      // else{
      //   $('.Product_image_badge').hide();
      // }

      $('.js.product-form__input.Color_selector').find('.form__label span').text(data);
      var data_handle = data.toLowerCase().replace(/ /g,'-').replace('š', 's').replace('ė', 'e').replace('ž', 'z').replace('ų', 'u').replace('ü', 'u').replace('é', 'e');
      $('.product-variant-id').attr('data-title', data_handle);
      $('.Product_main_image').hide();
      $('.Product_main_image').each(function(){
        var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
          if (current_color == data_handle ){
            console.log(current_color, data_handle);
              $(this).show();
          }
      });
    
    $('.product_main_images_slider').hide();
    $('.product_main_images_slider_nav').hide();
    $('.product_main_images_slider_nav').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').slick('refresh');
    $('.product_main_images_slider_nav').slick('refresh');
    // if ($(window).width() < 800) {
    // $('html, body').animate({
    //   scrollTop: $(".Product_images_mob").offset().top-50
    // }, 200);
    // }

    // STANDARD TEMPLATE =========== ORIGINAL TEMPLATE WILL BE ERROR FOR TEMPORARY
    // Filtering new variant gallery images
    $('.Product_images_standard_gallery_main').slick('slickUnfilter');
    $('.Product_images_standard_gallery_thumb').slick('slickUnfilter');
    console.log(data_handle, 'current color to be filtered');
    $('.Product_images_standard_gallery_main').slick('slickFilter', '.'+data_handle+'');
    $('.Product_images_standard_gallery_thumb').slick('slickFilter', '.'+data_handle+'');
  });

  function calculateButtonsStock(){
    // console.log('Calculating buttons stock');
    $('.product-form__input .Color_selector').each(function(){
      var currentClasses = $(this).attr('class'); // Get the current class list
      var color = currentClasses.replace('Color_selector', '').trim();
      // console.log(color);

      var colorTotalySoldout = 0;

      var fullVariantTitle = color;
      var SizeExists = 0;
      var currentInventory = 0;

      $('.Size_selector input[type=radio]+label').each(function(){
        SizeExists++;
        var currentSize = $(this).attr('class');
        currentSize = currentSize.replace('product_variant_option__', '');
        
        fullVariantTitle = color;
        fullVariantTitle = fullVariantTitle + '-' + currentSize;
        currentInventory = 0;
  
        $('.Product_form_variant_checker__js').each(function(){
          if ($(this).attr('data-handle') == fullVariantTitle){
            currentInventory = parseFloat($(this).attr('data-inv'));
          }
        });

        // console.log(fullVariantTitle, currentInventory, 'currentsize');

        if (currentInventory > 0){
          colorTotalySoldout++;
        }
      });

      if (SizeExists == 0){
        $('.Product_form_variant_checker__js').each(function(){
          if ($(this).attr('data-handle') == fullVariantTitle){
            currentInventory = parseFloat($(this).attr('data-inv'));
          }
        });

        if (currentInventory > 0){
          colorTotalySoldout++;
        }
      }
      // console.log(colorTotalySoldout, color);

      if (colorTotalySoldout == 0){
        $(this).addClass('totalySoldOut');
      }
    });

    // var allColorSelectorHtml = $('.product-form__input.Color_selector').html(); 

    // $('.product-form__input.Color_selector').html('');
    // $('.product-form__input.Color_selector').html(allColorSelectorHtml);

    // Select the parent container
    var colorSelector = $('.product-form__input.Color_selector');

    // Find all labels with the class "totalySoldOut"
    var soldOutItems = colorSelector.find('label.totalySoldOut');

    // Loop through each sold-out label
    soldOutItems.each(function() {
        var label = $(this); // Get the current label
        var input = label.prev('input'); // Get the input that comes before this label

        // Append the input and label to the end of the fieldset
        input.appendTo(colorSelector);
        label.appendTo(colorSelector);
    });



  }

  function calculateSizeStock(){

    $('.Size_selector input[type=radio]+label').removeClass('sizeSoldout');
    $('.Size_selector input[type=radio]+label').each(function(){
      var currentSize = $(this).attr('class');
      currentSize = currentSize.replace('product_variant_option__', '').replace(' ', '');

      // console.log(currentSize, 'SIZE OPTION');

      var color = String($('.product-form__input input[type=radio]:checked+label.Color_selector').attr('class'));
      color = color.replace('Color_selector', '');

      console.log('selected color', color);

      var fullTitle = '';
      fullTitle = color + '-' + currentSize;
      var currentInventory = 0;

      fullTitle = fullTitle.replace(' ','');
      // console.log(fullTitle);
      $('.Product_form_variant_checker__js').each(function(){
        if (fullTitle == $(this).attr('data-handle') ){
          console.log('MATCH', fullTitle);
          currentInventory = parseFloat($(this).attr('data-inv'));
        }
      });

      // console.log(currentInventory, currentSize, 'herererererererer');
      if (currentInventory < 1){
        $(this).addClass('sizeSoldout');
      }

    });
  }

  calculateButtonsStock();
  calculateSizeStock();

  $('.product-variant-id').change(function(){
    calculateSizeStock();

    var currentId = $(this).attr('value');
    var currentInventory = 0;
    $('.Product_form_variant_checker__js').each(function(){
      if ($(this).attr('data-id') == currentId){
        currentInventory = parseFloat($(this).attr('data-inv'));
      }
    });

    // Stock messages
    $('.Instock_message_line').hide();
    $('.Instock_message_line').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).css('display', 'flex');
      }
    });

    // Badges

    if (
      
      currentId == '50165836284229' ||
      currentId == '50165836316997' ||
      currentId == '50165836349765' ||
      currentId == '50165836382533' ||
      currentId == '50165836415301' || 
      currentId == '50165836448069' 
    ){
      $('.ssi_badge.bis_badge').show();
    } 
    else{
      $('.ssi_badge.bis_badge').hide();
    }

    console.log(currentInventory, 'STOCK');
    var currentLocation = String(window.location);
    if (currentLocation.indexOf('noreo-naturalaus-silko-pagalves-uzvalkalas') != -1 ){
      if (currentInventory < 1){
        $('.product-form .Product_atc_button').text('Sold out');
        $('.Product_atc_button').attr('data-stock', '0');
        $('.Product_atc_button_bundle').text('Sold out');
        $('.Product_atc_button_bundle').attr('data-stock', '0');
        // $('.Product_atc_button').text('Užsakyti iš anksto');
        // $('.Product_atc_button').attr('data-stock', '1');
        // $('.Product_atc_button_bundle').text('Add to cart');
        // $('.Product_atc_button_bundle').attr('data-stock', '1');
        $('.Shipping_content__js').hide();
        $('.Shipping_preoreder__js').show();
        // $('.Product_atc_button').text('Sold out');
        // $('.Product_atc_button').attr('data-stock', '1');
        // $('.Product_atc_button_bundle').text('Add to cart');
        // $('.Product_atc_button_bundle').attr('data-stock', '1');
        // $('.Shipping_content__js').hide();
        // $('.Shipping_preoreder__js').show();
        // $('.Product_form_shipping_features.green').find('p').text('IŠANKSTINIS UŽSAKYMAS');
        $('.mn_atc_btn_text__soldout').show();
        $('.mn_atc_btn_text__add').hide();
      }
      if (currentInventory > 0){
        $('.product-form .Product_atc_button').text('Add to cart');
        $('.Product_atc_button').attr('data-stock', '1');
        $('.Product_atc_button_bundle').text('Add to cart');
        $('.Product_atc_button_bundle').attr('data-stock', '1');
        $('.Shipping_content__js').show();
        $('.Shipping_preoreder__js').hide();
        $('.Product_form_shipping_features.green').find('p').text('GREITAS PRISTATYMAS');
        $('.mn_atc_btn_text__soldout').hide();
        $('.mn_atc_btn_text__add').show();
      }
    }
    else{
      if (currentInventory < 1){
        $('.product-form .Product_atc_button').text('Sold out');
        $('.Product_atc_button').attr('data-stock', '0');
        $('.Product_atc_button_bundle').text('Sold out');
        $('.Product_atc_button_bundle').attr('data-stock', '0');
        // $('.Product_atc_button').text('Užsakyti iš anksto');
        // $('.Product_atc_button').attr('data-stock', '1');
        // $('.Product_atc_button_bundle').text('Add to cart');
        // $('.Product_atc_button_bundle').attr('data-stock', '1');
        $('.Shipping_content__js').hide();
        $('.Shipping_preoreder__js').show();
        $('.mn_atc_btn_text__soldout').show();
        $('.mn_atc_btn_text__add').hide();
        
      }
      if (currentInventory > 0){
        $('.product-form .Product_atc_button').text('Add to cart');
        $('.Product_atc_button').attr('data-stock', '1');
        $('.Product_atc_button_bundle').text('Add to cart');
        $('.Product_atc_button_bundle').attr('data-stock', '1');
        $('.Shipping_content__js').show();
        $('.Shipping_preoreder__js').hide();
        $('.mn_atc_btn_text__soldout').hide();
        $('.mn_atc_btn_text__add').show();
      }

    }

    var currentUrl = window.location;
    var urlParams = new URLSearchParams(currentUrl.search);
    var variantId = currentId;
    urlParams.set('variant', variantId);
    var newUrl = currentUrl.origin + currentUrl.pathname + '?' + urlParams.toString();
    window.history.pushState({ path: newUrl }, '', newUrl);

    // Settuping back to stock signup form
    $('.stockSignup_klaviyo_form_outer').hide();
    $('.stockSignup_klaviyo_form_outer').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).show();
      }
    });

    if (currentInventory < 1){
      $('.stockSignUpForm_outer').show();
      if ($(window).width() < 800) {
        $('html, body').animate({
          scrollTop: $(".stockSignUpForm_outer").offset().top-200
        }, 500);
      }
    }
    else{
      $('.stockSignUpForm_outer').hide();
    }
  });


  // Product accordion functionality
  $('.Product_info_accordion_cell').click(function(){
      $(this).find('.inner').slideToggle();
      $(this).find('.accordion_img').toggle();
  });

  // Product carousel mobile gallery
  $('.product_main_images_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.product_main_images_slider_nav',
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });


  $('.pke_main_gallery').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });

  // $('.pke_main_gallery_thumb').slick({
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrow: false,
  //   asNavFor: '.pke_main_gallery',
  //   focusOnSelect: true
  // });
  


  $('.product_main_images_slider_nav').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product_main_images_slider',
    focusOnSelect: true
  });

// Product section, size chart popup
  $('.Product_variant_size_chart').click(function(){
    $('.Product_popup_whole').css('display', 'flex');
  });

  $('.Product_popup_inner_close').click(function(){
    $('.Product_popup_whole').hide();
  });

// Features Switch
$('.Product_features_nav_bubble').click(function(){
  var data = $(this).attr('data');
  $('.Product_features_image__js').hide();
  $('.Product_features_image__js').each(function(){
    if ($(this).attr('data') == data){
      $(this).show();
    }
  });
});

// Faq
$('.Faq_accordion_cell').click(function(){
  $(this).toggleClass('active');
  $(this).find('.Faq_accordion_content').slideToggle();
});

// Scroll animation

$('.scroll_to_js').click(function(){
  $('html, body').animate({
    scrollTop: $(".Product_section_main").offset().top-100
}, 200);
});

// Carousel slick
$('.Product_page_gallery_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

  $('.Product_gallery_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

// Hero banner cta functionality
  $('.Product_hero_cta_box').click(function(){
    $('html, body').animate({
      scrollTop: $(".Product_section_main").offset().top
  }, 200);
  });

  // Sticky header
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
        // Customer has scrolled below 400 pixels from the top
        // $('.Product_header_outer.Bottom').css('bottom', '0');
        // Add your desired code or actions here
    }
    else{
      // $('.Product_header_outer.Bottom').css('bottom', '-300px');
    }
  });

  $('.Bundle_about_line').click(function(){
    $(this).parent('.Bundle_about_accordion_item').toggleClass('active');
    $(this).parent('.Bundle_about_accordion_item').find('.content').slideToggle();
  });

  // Button scrolling to reviews
  $('.Bundle_page_button').click(function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Bundle_judge_reviews_outer").offset().top-120
  }, 400);
  });


  // Ugc play video
  $('.Product_ugc_play_button').click(function(){
    $(this).hide();
    $(this).parent('div').find('.Product_ugc_pause_button').show();
    console.log('Play');
    var video = $(this).parent('div').find('video')[0];
    if (video) {
        video.play();
    }
  });
  $('.Product_ugc_pause_button').click(function(){
    $(this).hide();
    $(this).parent('div').find('.Product_ugc_play_button').show();
    console.log('Pause');
    var video = $(this).parent('div').find('video')[0];
    if (video) {
      video.pause(); 
      video.currentTime = 0;
    }
  });

  $('.Mobile_ProductS_ugc_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

  $(".Quiz_hero_carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-round-forward-1.png?v=1700571436'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-round-forward.png?v=1700571437'/></button>",
  });

  $('.Quiz_offer_button').click(function(evt){
    if ($(this).hasClass('quiz_button')){

    }
    else{
      evt.preventDefault();
      $('html, body').animate({
          scrollTop: $(".Product_section_main").offset().top
      }, 200);
    }
   
  });

  // Standard product page details

  $(document).on('click','.Product_price_badge_standard',function(){
    // console.log('Click');
    $('.Product_price_info_note').toggle();
    setTimeout(function(){
      $('.Product_price_info_note').toggleClass('active');
    },100);
  });

  $('.Product_section_main').click(function (e) {
    // Check if the clicked element or any of its ancestors have the class .Product_price_badge_standard
    if ($(e.target).closest('.Product_price_badge_standard').length === 0) {
        // Clicked outside .Product_price_badge_standard, hide .Product_price_info_note
        $('.Product_price_info_note').removeClass('active');
        setTimeout(function () {
            $('.Product_price_info_note').hide();
        }, 100);
    }
  });


  $('.Product_images_standard_gallery_main').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2524.png?v=1686900777'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2523.png?v=1686900776'/></button>",
    asNavFor: '.Product_images_standard_gallery_thumb',
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: false,
          arrows: false
        }
      }
    ]
  });

  $('.Product_images_standard_gallery_thumb').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.Product_images_standard_gallery_main',
    focusOnSelect: false
  });

  // Gallery popup
  $('.Product_images_gallery_zoomin').click(function(){
    var dataSrc = $(this).attr('data-src');
    $('.Product_images_popup_overlay img').attr('src', dataSrc);
    $('.Product_images_popup_overlay').css('display', 'flex');
    setTimeout(function(){
      $('.Product_images_popup_overlay').css('opacity', '1');
    },500);
  });

  $('.Product_images_popup_overlay').click(function(){
    $('.Product_images_popup_overlay').css('opacity', '0');
    setTimeout(function(){
      $('.Product_images_popup_overlay').hide();
    },300);
  });


  $('.Product_images_standard_gallery_thumb .slick-slide').click(function(){
      var currentIndex = $(this).attr('data-slick-index');
      var activeIndex = $('.Product_images_standard_gallery_thumb .slick-slide.slick-current').attr('data-slick-index');
      var currentDiffer = parseFloat(currentIndex) - parseFloat(activeIndex);
      // console.log(currentDiffer, 'INDEXES ======  ');
      var stopCounting = false;
      var index = 0;
      $('.Product_images_standard_gallery_thumb .slick-slide').each(function () {
        if (stopCounting) {
            return false; 
        }
        index++;
        if ($(this).hasClass('slick-current')) {
            stopCounting = true;
        }
    });
      index = index + currentDiffer -1;
      console.log(index, 'INDEX current');

      $('.Product_images_standard_gallery_main').slick('slickGoTo', index);
  });

  $('.gs_select_size_btn').mouseover(function(){
    $(this).addClass('hovered');
  });

  $('.gs_select_size_btn').mouseleave(function(){
    $(this).removeClass('hovered');
  });

  $('.gs_go_back').mouseover(function(){
    $(this).addClass('hovered');
  });

  $('.gs_go_back').mouseleave(function(){
    $(this).removeClass('hovered');
  });

  $('.det_inn').click(function(){
    $('.det_inn').removeClass('active');
    $(this).addClass('active');
    var data = parseFloat($(this).attr('data'));
    $('.quantity__input').attr('value', data);
    $('.quantity__input').val(data);
  });

  $('.detu_expand_upsell').click(function(){
    var data = $(this).attr('data');
    if (data == '1'){
      $(this).attr('data', '0');
      $(this).html('Rodyti mažiau');
    }
    else{
      $(this).attr('data', '1');
      $(this).html('Apie produktą');
    }
    $('.detu_expandable').slideToggle();
  });

  $('.detu_qty_plus').click(function(){
    var value = parseFloat($('.detu_qty_val').html());
    value++;
    $('.detu_qty_val').html(value);
  });

  $('.detu_qty_min').click(function(){
    var value = parseFloat($('.detu_qty_val').html());
    if (value > 1){
      value--;
    }
    
    $('.detu_qty_val').html(value);
  });



  // Upsell offer

  $('.nlu_pillow_select__js').change(function(){
    var pillow_id = $(this).val();
    var pillow_title = $('.nlu_piilow_checker[data-id="'+pillow_id+'"]').attr('data-title');
    console.log(pillow_title );
    $('.pillow_img').hide();
    if (pillow_title.indexOf('perlo-balta') != -1){
      $('.pillow_img[data="perlu-balta"]').show();
    }
    else if (pillow_title.indexOf('balta') != -1){
      $('.pillow_img[data="balta"]').show();
    }
    else if (pillow_title.indexOf('levand') != -1){
      $('.pillow_img[data="levanda"]').show();
    }
    else if (pillow_title.indexOf('sviesiai-melyna') != -1){
      $('.pillow_img[data="sviesiai-melyna"]').show();
    }
    else if (pillow_title.indexOf('tamsiai-pilka') != -1){
      $('.pillow_img[data="tamsiai-pilka"]').show();
    }
    else if (pillow_title.indexOf('pilka') != -1){
      $('.pillow_img[data="pilka"]').show();
    }
    else if (pillow_title.indexOf('juoda') != -1){
      $('.pillow_img[data="juoda"]').show();
    }
    else if (pillow_title.indexOf('ruda') != -1){
      $('.pillow_img[data="ruda"]').show();
    }
    else if (pillow_title.indexOf('zalia') != -1){
      $('.pillow_img[data="zalia"]').show();
    }
    else if (pillow_title.indexOf('tamsiai-melyna') != -1){
      $('.pillow_img[data="tamsiai-melyna"]').show();
    }
    else if (pillow_title.indexOf('melyna') != -1){
      $('.pillow_img[data="melyna"]').show();
    }
    else if (pillow_title.indexOf('balta') != -1){
      $('.pillow_img[data="balta"]').show();
    }
    else if (pillow_title.indexOf('pelenu') != -1){
      $('.pillow_img[data="pelenu"]').show();
    }
    else if (pillow_title.indexOf('rozine') != -1){
      $('.pillow_img[data="rozine"]').show();
    }
    else if (pillow_title.indexOf('raudona') != -1){
      $('.pillow_img[data="raudona"]').show();
    }
    else if (pillow_title.indexOf('sampanine') != -1){
      $('.pillow_img[data="sampanine"]').show();
    }
    else if (pillow_title.indexOf('kremine') != -1){
      $('.pillow_img[data="kremine"]').show();
    }
  });


  $('.nlu_eukalipt_change').change(function(){
  
    $('.nlu_eukalipt_change').each(function(){
      var value = $(this).val();
      if (value == '150x200'){
        $('.nlu_eukalipt_change').each(function(){
          var optionValue = $(this).val();
          if (
             String(optionValue).indexOf('160x200') != -1
          || String(optionValue).indexOf('180x200') != -1
          || String(optionValue).indexOf('240x260') != -1){
            $(this).val('90x200');
            $(this).find('option').hide();
            $(this).find('option[value="90x200"]').show();
          }
        });
      }
      else if (value == '200x200' || value == '200x220'){
        $('.nlu_eukalipt_change').find('option').show();
        $('.nlu_eukalipt_change').find('option[value="90x200"]').hide();
        $('.nlu_eukalipt_change').each(function(){
          var optionValue = $(this).val();
          if (
             String(optionValue).indexOf('90x200') != -1){
            $(this).val('160x200');
          }
        });
      }
    });

    var fullTitle = '';
    $('.nlu_eukalipt_change').each(function(){
      var thisVal = $(this).val();
      fullTitle = fullTitle + '-' + thisVal;
    });
    fullTitle = fullTitle.substring(1);

    $('.nlu_pa_price').hide();
    $('.nlu_pa_price').removeClass('active');
    $('.nlu_pa_price').each(function(){
      if ($(this).attr('data-title') == fullTitle){
        $(this).show();
        $(this).addClass('active');
      }
    });

    $('.eukalipt_img').hide();
    if (fullTitle.indexOf('kremine') != -1){
      $('.eukalipt_img[data="kremine"]').show();
    }
    else if(fullTitle.indexOf('pilka') != -1){
      $('.eukalipt_img[data="pilka"]').show();
    }
    else if(fullTitle.indexOf('balta') != -1){
      $('.eukalipt_img[data="balta"]').show();
    }
  });





  // Timer
   // Target date and time (November 23, 2023)
  //  var targetDate = new Date("2023-11-29T00:00:00").getTime();

  //  var timer = setInterval(function () {
  //      var currentDate = new Date().getTime();
  //      var timeLeft = targetDate - currentDate;

  //      if (timeLeft <= 0) {
  //          clearInterval(timer);
  //          $('.Product_header_timer_inner').html('Countdown expired');
  //      } else {
  //          var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  //          var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //          var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  //          var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  //          $('.Product_header_timer_days .timing').text(days);
  //          $('.Product_header_timer_hours .timing').text(hours);
  //          $('.Product_header_timer_minutes .timing').text(minutes);
  //          $('.Product_header_timer_seconds .timing').text(seconds);
  //      }
  //  }, 1000); // Update every 1 second

});


// document.querySelectorAll('.gs_continue_btn').forEach(button => button.addEventListener('click', e => {
//   if(!button.classList.contains('soldout')) {
//     if(!button.classList.contains('loading')) {

//         button.classList.add('loading');

//         setTimeout(() => button.classList.remove('loading'), 2500);

//     }
//   }
//   e.preventDefault();
// }));



$('.pke_option_grid_block').click(function(){
  $(this).closest('.pke_option_grid').find('.pke_option_grid_block').removeClass('active');
  $(this).addClass('active');
  
  var color = '.'+$('.pke_color_box.active').attr('data-title');

  $('.pke_main_gallery').slick('slickUnfilter');
  $('.pke_main_gallery').slick('slickFilter', color);

  var varTitle = '';
  $(this).closest('.pke_outer').find('.pke_option_grid_block.active').each(function(){
    var currentTitle = $(this).attr('data-title');
    varTitle = varTitle + '-' + currentTitle;
  });

  varTitle = varTitle.substring(1);

  var currentId = $('.pke_eu_variant_checker[data-title="'+varTitle+'"]').attr('data-id');
  var currentInv = $('.pke_eu_variant_checker[data-title="'+varTitle+'"]').attr('data-inv');

  if (currentInv == '0'){
    $('.pke_atc_btn').html('Sold out');
  }
  else{
    $('.pke_atc_btn').html('Add to cart');
  }
  $(this).closest('.pke_outer').find('.pke_price_line').hide();
  $(this).closest('.pke_outer').find('.pke_price_line[data-id="'+currentId+'"]').css('display', 'flex');

  $(this).closest('.pke_outer').find('.pke_atc_btn').attr('data-id', currentId);
  console.log(currentId);


});

